function HouseDetails({ house, goBack }) {
  return (
    <div
      style={{
        minHeight: "100vh",

        background:
          "linear-gradient(135deg,#000000,#222222)",

        padding: "30px"
      }}
    >
      <button
        onClick={goBack}
        style={{
          backgroundColor: "#ffd600",

          color: "black",

          border: "none",

          padding: "12px 22px",

          borderRadius: "12px",

          fontWeight: "bold",

          cursor: "pointer"
        }}
      >
        ⬅ Back
      </button>

      <div
        style={{
          maxWidth: "750px",

          margin: "30px auto",

          backgroundColor: "#1a1a1a",

          border: "3px solid #ffd600",

          borderRadius: "25px",

          padding: "35px",

          color: "white",

          boxShadow:
            "0 0 25px rgba(255,214,0,0.4)",

          animation: "slideUp .7s ease"
        }}
      >
        <h1
          style={{
            textAlign: "center",

            color: "#ffd600",

            fontSize: "45px"
          }}
        >
          🏠 House Details
        </h1>

        <hr
          style={{
            border: "1px solid #ffd600",

            marginBottom: "25px"
          }}
        />

        <p style={{ fontSize: "20px" }}>
          <strong>🌍 Town:</strong>{" "}
          {house.town}
        </p>

        <p style={{ fontSize: "20px" }}>
          <strong>📍 Area:</strong>{" "}
          {house.area}
        </p>

        <p style={{ fontSize: "20px" }}>
          <strong>🏘 Estate:</strong>{" "}
          {house.estate ||
            "Not Applicable"}
        </p>

        <p style={{ fontSize: "20px" }}>
          <strong>🏢 Plot Name:</strong>{" "}
          {house.plotName}
        </p>

        <p style={{ fontSize: "20px" }}>
          <strong>🏠 House Type:</strong>{" "}
          {house.houseType}
        </p>

        <p style={{ fontSize: "20px" }}>
          <strong>💰 Rent:</strong> KES{" "}
          {house.rent}
        </p>

       <div
  style={{
    marginTop: "25px",
    background: "#fff8d6",
    padding: "18px",
    borderRadius: "15px",
    borderLeft: "6px solid #ffd600",
    color: "black"   // Makes all text black
  }}
>
  <h2
    style={{
      marginTop: 0,
      marginBottom: "15px",
      color: "black"
    }}
  >
    📞 Contact Details
  </h2>

  <p style={{ color: "black" }}>
    <strong>Landlord:</strong>{" "}
    {house.landlordName || "Not provided"}
  </p>

  <p style={{ color: "black" }}>
    <strong>Contact:</strong>{" "}
    <a
      href={`tel:${house.contact}`}
      style={{
        color: "#0066cc",
        textDecoration: "none",
        fontWeight: "bold"
      }}
    >
      {house.contact}
    </a>
  </p>

  {house.email && (
    <p style={{ color: "black" }}>
      <strong>Email:</strong>{" "}
      <a
        href={`mailto:${house.email}`}
        style={{
          color: "#0066cc",
          textDecoration: "none",
          fontWeight: "bold"
        }}
      >
        {house.email}
      </a>
    </p>
  )}
</div>
        <div
          style={{
            marginTop: "30px",

            backgroundColor: "#ffd600",

            color: "black",

            padding: "15px",

            borderRadius: "15px",

            textAlign: "center",

            fontWeight: "bold",

            fontSize: "20px"
          }}
        >
          ✅ Available For Rent
        </div>
      </div>

      <style>

        {`

        @keyframes slideUp{

          from{

            opacity:0;

            transform:
            translateY(80px);

          }

          to{

            opacity:1;

            transform:
            translateY(0);

          }

        }

      `}

      </style>

    </div>
  );
}

export default HouseDetails;